import BaseApi from '../base/base'
import Exam from '../../models/exam'
import { RequestMode } from '../api_constant'
import { ExamQScoreHistory } from '../../models/q_score_history'

export default class ExamApi extends BaseApi {
  constructor() {
    super()
    this.path = '/exams'
  }

  async index(params = { page: 1, categoryId: ""}) {
    this.path = '/exams'
    const response = await this.getRequest({...params})
    return [
      response.meta.pagination,
      response.data.map((element) => {
        return new Exam(element)
      })
    ]
  }

  async recommendation(params = { page: 1}) {
    this.path = '/exams/recommendation'
    const response = await this.getRequest({...params})
    return [
      response.meta.pagination,
      response.meta.untestCount,
      response.data.map((element) => {
        return new Exam(element)
      })
    ]
  }

  async my(params = {}) {
    this.path = '/exams/my'
    const response = await this.getRequest({...params})
    return [
      response.meta.category,
      response.data.map((element) => {
        return new Exam(element)
      },
      ),
      response.meta.hasAnyExam,
      response.meta.totalCount
    ]
  }

  async showForTest(examId, params, getType = "normal") {
    return this.show(examId, params, RequestMode.TEST, getType)
  }

  async showForResult(examId, params) {
    return this.show(examId, params, RequestMode.DETAIL)
  }

  async showForSummary(examId, params) {
    return this.show(examId, params, RequestMode.EXAM_SUMMARY)
  }

  private async show(examId, params, mode = RequestMode.DETAIL, getType = "normal") {
    this.path = `/exams/${examId}`
    const response = await this.getRequest({...params, mode, getType})
    return new Exam(response.data)
  }

  async join(examId) {
    this.path = `/exams/${examId}/join`
    await this.postRequest()
    return true
  }

  async rejoin(examId, examType: string): Promise<{examId: number, userExamId: number}> {
    this.path = `/exams/${examId}/rejoin`
    const response =  await this.postRequest({ examType })
    return response.data
  }

  async clearAll(examId): Promise<{examId: number}> {
    this.path = `/exams/${examId}/clear_all`
    const response =  await this.postRequest()
    return response.data
  }

  async qScoreHistories(examId) {
    this.path = `/exams/${examId}/q_score_histories`
    const response =  await this.getRequest()
    return new ExamQScoreHistory(response.data)
  }

  async search(params) {
    this.path = `/exams/search`
    const response = await this.getRequest(params)
    return [
      response.meta.pagination,
      response.data.map((element) => {
        return new Exam(element)
      })
    ]
  }
  async my_search(params) {
    this.path = `/exams/my_search`
    const response = await this.getRequest(params)
    return [
      response.meta.category,
      response.data.map((element) => {
        return new Exam(element)
      },
      ),
      response.meta.hasAnyExam
    ]
  }
}
